// extracted by mini-css-extract-plugin
export default {"wrap":"EmptyState_wrap__4VfD3","icon":"EmptyState_icon__UzGFh","title":"EmptyState_title__a8Apb","desc":"EmptyState_desc__I+tf9"};